import React from 'react';
import { Typography, Paper, Grid, Card, CardContent, CardHeader, Avatar } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import HelpIcon from '@mui/icons-material/Help';
import EventIcon from '@mui/icons-material/Event';
import PollIcon from '@mui/icons-material/Poll';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

const AITalkerUseCases = () => {
  const useCases = [
    {
      icon: <SupportAgentIcon />,
      title: "Customer Support",
      description: "Provide 24/7 customer support, handle inquiries, and resolve common issues quickly and efficiently."
    },
    {
      icon: <ShoppingCartIcon />,
      title: "Sales and Lead Generation",
      description: "Engage potential customers, qualify leads, and guide them through the sales funnel."
    },
    {
      icon: <HelpIcon />,
      title: "FAQ and Information Retrieval",
      description: "Answer frequently asked questions and provide instant access to information across various topics."
    },
    {
      icon: <EventIcon />,
      title: "Appointment Scheduling",
      description: "Manage bookings, send reminders, and handle rescheduling requests for various service industries."
    },
    {
      icon: <PollIcon />,
      title: "Surveys and Feedback Collection",
      description: "Conduct interactive surveys, collect customer feedback, and gather valuable insights for your business."
    },
    {
      icon: <LocalHospitalIcon />,
      title: "Healthcare Assistance",
      description: "Provide initial health assessments, medication reminders, and general health information to patients."
    }
  ];

  return (
    <Paper elevation={0}>
      <Typography variant="h4" gutterBottom>AI Talker Use Cases</Typography>
      <Typography paragraph>
        AI Talker is a versatile tool that can be applied across various industries and scenarios. 
        Here are some of the most common and effective use cases for our AI Talker technology:
      </Typography>
      <Grid container spacing={3}>
        {useCases.map((useCase, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardHeader
                avatar={
                  <Avatar>
                    {useCase.icon}
                  </Avatar>
                }
                title={useCase.title}
              />
              <CardContent>
                <Typography variant="body2" color="text.secondary">
                  {useCase.description}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      <Typography variant="h6" style={{ marginTop: '20px' }}>Implementing AI Talker in Your Business:</Typography>
      <Typography paragraph>
        1. <strong>Identify Your Needs:</strong> Assess your business processes and customer interaction points to determine where AI Talker can add the most value.
      </Typography>
      <Typography paragraph>
        2. <strong>Customize the AI:</strong> Tailor AI Talker's knowledge base, personality, and responses to align with your brand and specific use case.
      </Typography>
      <Typography paragraph>
        3. <strong>Integration:</strong> Seamlessly integrate AI Talker with your existing systems, such as CRM, helpdesk, or booking software.
      </Typography>
      <Typography paragraph>
        4. <strong>Training and Onboarding:</strong> Prepare your team for working alongside AI Talker and establish protocols for handling complex scenarios.
      </Typography>
      <Typography paragraph>
        5. <strong>Monitor and Optimize:</strong> Regularly review AI Talker's performance and user feedback to continuously improve its effectiveness.
      </Typography>
      <Typography paragraph>
        AI Talker is designed to be adaptable to a wide range of industries and use cases. Whether you're 
        looking to improve customer service, streamline sales processes, or enhance user engagement, 
        AI Talker can be customized to meet your specific needs and goals.
      </Typography>
      <Typography paragraph>
        Our team of experts is available to help you explore how AI Talker can be best implemented 
        in your business. Contact us to discuss your unique use case and discover the potential of 
        AI-powered conversations for your organization.
      </Typography>
    </Paper>
  );
};

export default AITalkerUseCases;
